import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import { SubHeading, YesNoBadge } from '../common/forms/FormElements';

export class GisLocationDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: null,
        };
    }

    render() {
        const { arcGisLocations } = this.props;
        const { filter } = this.state;

        const locationCount =
            arcGisLocations && arcGisLocations.length
                ? arcGisLocations.length
                : 0;
        const activeLocationCount =
            locationCount > 0
                ? arcGisLocations.filter((agl) => agl.isActive).length
                : 0;

        const filteredLocations = (arcGisLocations || []).filter(
            (agl) =>
                !filter ||
                agl.addrLoc.toLowerCase().includes(filter.toLowerCase()) ||
                agl.addrLoc.toLowerCase().includes(filter.toLowerCase())
        );

        const activeFilteredCount = filteredLocations.length;
        const filteredRecordCount = locationCount - activeFilteredCount;

        return (
            <>
                <Row>
                    <Col>
                        <SubHeading>Locations</SubHeading>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <div className="container-fluid ml-3 pl-1 text-muted font-weight-bold align-items-center">
                            <div>
                                {locationCount} total, {activeLocationCount}{' '}
                                active.
                                {filteredRecordCount > 0 && (
                                    <span className="ml-1">
                                        {filteredRecordCount} locations hidden
                                        by active filter.
                                    </span>
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <Input
                                    type="text"
                                    className="float-right mr-3 w-75"
                                    size="sm"
                                    value={filter}
                                    onChange={(e) =>
                                        this.setState({
                                            filter: e.target.value,
                                        })
                                    }
                                    placeholder="Filter locations"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="container-fluid simple-table-container">
                            <table className="table table-sm">
                                <thead>
                                    <tr className="sticky-thead">
                                        <th>Address / Location</th>
                                        <th>Active</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(!arcGisLocations ||
                                        !arcGisLocations.length) && (
                                        <tr>
                                            <td colSpan={7}>
                                                No phases configured.
                                            </td>
                                        </tr>
                                    )}
                                    {filteredLocations &&
                                        filteredLocations.map((agl) => (
                                            <tr key={agl.id}>
                                                <td>{agl.addrLoc}</td>
                                                <td>
                                                    <YesNoBadge
                                                        value={agl.isActive}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}
